import dayjs from 'dayjs'

export interface ICalculateETA {
  ETAMax?: string
  ETAMin?: string
  initialTime: string | Date
}

export const calculateETA = ({
  ETAMax,
  ETAMin,
  initialTime,
}: ICalculateETA) => {
  let max = ETAMax
  let min = ETAMin

  const initialTimeRounded = dayjs(initialTime).second(0).millisecond(0)

  if (max) {
    const ETAmaxRounded = dayjs(ETAMax).second(0).millisecond(0)
    max = `${dayjs(ETAmaxRounded).diff(initialTimeRounded, 'minutes')}`
  }

  if (min) {
    const ETAminRounded = dayjs(ETAMin).second(0).millisecond(0)
    min = `${dayjs(ETAminRounded).diff(initialTimeRounded, 'minutes')}`
  }

  return {
    ETAMax: max,
    ETAMin: min,
  }
}
